// Copyright (c) 2019-present Ladifire, Inc. All Rights Reserved.
// See LICENSE.txt for license information.
import {createTheme} from '../utils/create_theme';
import {GlobalThemeTokens} from '../types';

// Create default global light theme
export default createTheme<GlobalThemeTokens, any>(() => ({
    mode: 'dark',
}));
